import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { RootState } from "../../redux/store";
import { useRef } from "react";
import { clearBulkData } from "../../redux/slices/bulkUploadSlice";
import { closeModal } from "../../redux/slices/modalSlice";
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";
import { BulkUpload } from "../../containers/AdvanceTable/BulkUpload";

export const BulkUploadModal: React.FC<{ organizationId: string }> = ({
  organizationId,
}) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(
    (state: RootState) => state.modals.bulkUploadModal
  );
  const fileInputRef = useRef<HTMLInputElement | null>(null);
   const { t } = useTranslation();

  const handleCancelClick = () => {
    dispatch(clearBulkData());

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    dispatch(closeModal("bulkUploadModal"));
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => dispatch(closeModal("bulkUploadModal"))}
      shouldCloseOnOverlayClick={false}
      contentLabel="Bulk Upload"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2000,
        },
        content: {
          inset: "unset",

          maxHeight: "90vh",
          overflowY: "auto",
          borderRadius: "14px",
          padding: "20px 25px",
          backgroundColor: "#fff",
          border: "none",
          width: "95%",         
          maxWidth: "1400px",   
        },
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: "20px" }}>
        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600, color: '#222' }}>
           {t('bulkUpload.BulkUpload')}
        </h2>
        <button

          style={{
            background: 'transparent',
            border: 'none',
            fontSize: '22px',
            fontWeight: 'bold',
            cursor: 'pointer',
            color: '#888',
            lineHeight: 1,
          }}
          onClick={handleCancelClick}
        >
          ×
        </button>
      </div>
      <BulkUpload organizationId={organizationId} />
    </Modal>
  );
};